import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import { Helmet } from 'react-helmet'
import { Actions } from '../actions';
import { connect } from 'react-redux';
import {
    GlobalStyles,
    GlobalScrollbar,
    GlobalFonts,
    Toast,
} from "@diversioteam/diversio-ds";
import Loader from "../components/utils/Loader";
import {urlMap} from '../dashboardRoutes';
import TopNavBar from "../components/TopNavBar";
import IdleTimer from 'react-idle-timer'
import _ from 'underscore';
import queryString from 'query-string'
import mixpanel from "mixpanel-browser";
import { beaconIdentify, beaconInit, beaconShowNps } from "../utils/beacon";
import {withTranslation} from "react-i18next";
import TAXONOMIES from "../utils/taxonomies";
import { featureFlagger } from '../featureFlagger';
import { Company } from './Company';
import { SurveyInformation } from 'components/SurveyInformation';
import { VersionsContext } from 'context/versions/versionsContext/VersionsContext';
import { withHooks } from 'config/withHooks/withHooks';
import { getActiveCompany } from 'utils';
import './App.scss';
import { VersionSwitch } from 'components/HomeV2/VersionSwitchModal';
import { DashboardProviders } from 'providers/DashboardProviders';
import { RenewDialog } from 'components/RenewDialog';
import { Tour } from 'components/Tour';
import { Navbar } from 'components/Navbar';
import { getAuthToken } from 'api/actions/auth/authActions';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = null;
        this.state = {
            mixpanelGroupSet: "",
            mixpanelInitialized: false,
            activeDashboard: {
                label: "",
                value: ""
            },
            pastSurveysActive: false,
            isNavbarInFocus: false
        }
    }

    async componentWillMount () {
        await featureFlagger.loadFeatures()

        if (this.props.isAuthenticated) {
            // The following data is used on a number of pages so we retrieve it upon successful login.
            // For users with access to multiple companies, this data is loaded again for the selected
            // dashboard with the createActiveDashboard() saga.
            this.props.getCompanyFilters();
            this.props.getProfile();

            const username = this.props.username;
            const email = this.props.email;
            const user_id = this.props.loggedinUserId;
            
            const companyName = getActiveCompany(this.props.userMetadata?.companies)?.name

            beaconInit()
            beaconIdentify(username, email)

            featureFlagger.setAttributes({
                id: String(user_id),
                company: companyName,
            })

            if (this.props.showNps == true) {
                beaconShowNps()
            }

            window.__STORAGE_HANDLER__ = e => {
                if (e.key === 'auth_access_token' && e.oldValue && !e.newValue) {
                    this.props.doSignout();
                }
            };

            window.addEventListener('storage', window.__STORAGE_HANDLER__, true);
        }
    }

    componentDidMount () {
        window.addEventListener("unload", this.handleTabClose = (e) => {
            mixpanel.track(TAXONOMIES.DASHBOARD_SESSION_ENDED, {
                dashboardName: getActiveCompany(this.props.userMetadata?.companies)?.name,
                action: "Window or tab closed"
            }, {transport: "sendBeacon"});
        })
    }


    componentWillUnmount () {
        window.removeEventListener("unload", this.handleTabClose)
    }

    handleOnAction () {
        let accessToken = getAuthToken('access');
        let refreshToken = getAuthToken('refresh');

        this.props.doRefreshToken({ accessToken, refreshToken });
    }

    makeRedirect = (authCheck, permissions) => {
        const makeRedirectString = (authCheck, permissions) => {
            const {
                homeAuthCheck,
                ilnAuthCheck,
            } = authCheck;

            if (homeAuthCheck) {
                if(permissions.ilnDashboardHome) {
                    return "/iln-dashboard/home";
                }
            }

            if (ilnAuthCheck) {
                if(permissions.home) {
                    return "/home"; }
            }

            return null;
        }

        const redirectString = makeRedirectString(authCheck, permissions);

        if (redirectString) {
            return <Redirect to={redirectString} />
        } else {
            return null;
        }
    }



    componentDidUpdate(prevProps) {
        const activeCompany = getActiveCompany(this.props.userMetadata?.companies)
        const prevCompanyName = getActiveCompany(prevProps.userMetadata?.companies)?.name
        const currCompanyName = activeCompany?.name
        const organizationName = activeCompany?.organization.name

        if (!this.props.loggedinUserId || !currCompanyName) {
            return
        }

        const username = this.props.username;
        const email = this.props.email;
        const user_id = this.props.loggedinUserId;
        const dashboardSwitchPage = this.props.history.location.pathname === '/choose-dashboard'


        if (!dashboardSwitchPage 
            && (!this.state.mixpanelInitialized || (prevCompanyName !== currCompanyName))) {
            this.setState({
                mixpanelInitialized: true
            })
            
            featureFlagger.setAttributes({
                id: String(user_id),
                company: currCompanyName,
            })

            mixpanel.identify(user_id);

            mixpanel.time_event(TAXONOMIES.DASHBOARD_SESSION_ENDED)

            mixpanel.people.set({
                $username: username,
                $email: email,
                user_id: user_id,
                Organization: organizationName
            });

            mixpanel.register({
                Company: currCompanyName,
                CompanyUUID: activeCompany?.uuid,
                Organization: organizationName,
                OrganizationUUID: activeCompany?.organization.uuid
            });
        }
    }

    handleCompanySelect (uuid) {
        if (typeof uuid !== "string") {
            return
        }

        const { companies } = this.props.userMetadata
        const foundCompany = _.findWhere(companies, { uuid })
        if (!foundCompany) {
            return
        }
        const activeCompanyName = foundCompany.name
        const username = this.props.username;

        mixpanel.track(TAXONOMIES.DASHBOARD_SESSION_ENDED, {
            dashboardName: activeCompanyName,
            user: username,
            action: 'dashboard switch'
        });

        window.open(
            `/company/${foundCompany.uuid}/home`,
            '_blank'
        )
    }

    setActiveDashboard(company) {
        this.setState({
            activeDashboard: {
                label: company.company,
                value: company.uuid
            }
        })
    }

    showPastSurveys (status) {
        this.setState({
            pastSurveysActive: status
        })
    }



    render() {
        const { companies } = this.props?.userMetadata || {}
        const companyInformation = getActiveCompany(companies)

        const permissions = companyInformation?.permissions

        if (permissions) {
            permissions.new_analyze = permissions.hasOwnProperty("new_analyze") ? permissions.new_analyze : true;
            permissions[urlMap.analyze_diversity] = permissions.hasOwnProperty("new_analyze") && true,
            permissions[urlMap.analyze_inclusion] = permissions.hasOwnProperty("new_analyze") && true
        }
        
        const { selectedLanguage, handleLanguageChange } = this.props;

        if (!this.props.isAuthenticated) {
            const clearBeforeSignout = sessionStorage.getItem("clear_before_signout") === "true"
            
            if (clearBeforeSignout) {
                sessionStorage.removeItem("companyUUID")
                sessionStorage.removeItem("clear_before_signout")

                this.props.queryClient.removeQueries()

                return <Redirect
                            to={{
                            pathname: "/login",
                            state: { resetMixpanel: true }
                            }}
                        />
              
            }
            const { to: defaultRedirectsTo } = queryString.parse(location.search)

            if (defaultRedirectsTo) {
                return <Redirect to={`/login?to=${encodeURIComponent(defaultRedirectsTo)}`}></Redirect>
            } else {
                if (location.pathname !== "/" && sessionStorage.getItem("companyUUID")) {
                    return <Redirect to={`/login?to=${encodeURIComponent(location.pathname + location.search)}`}></Redirect>
                } else {
                    return <Redirect to={`/login`}></Redirect>
                }
                
            }
        }

        if (!permissions) {
            return <Loader />;
        }

        const dashboardSwitch = this.props.history.location.pathname === '/choose-dashboard'
        const url = this.props.history.location.pathname;

        // By adding the trailing slash '/' to each auth check, it will redirect to the base home page for a specific dashboard
        const translatedPages = [
            '/',
            '/home',
            '/analyze/diversity',
            '/analyze/inclusion'
        ];

        const homeAuthUrls = [
            '/',
            '/home',
            '/analyze/diversity',
            '/analyze/inclusion',
        ]

        const ilnAuthUrls = [
            '/',
            '/iln-dashboard/home',
            '/iln-dashboard/impact'
        ]

        const homeAuthCheck = homeAuthUrls.indexOf(url) > -1 && !permissions.home
        const ilnAuthCheck = ilnAuthUrls.indexOf(url) > -1 && !permissions.ilnDashboardHome

        const authCheck = {
            homeAuthCheck,
            ilnAuthCheck,
        };

        const possibleRedirect = this.makeRedirect(authCheck, permissions);
        if (possibleRedirect) {
            return possibleRedirect;
        }

        const companyName = companyInformation?.name
        if(this.state.mixpanelGroupSet !== companyName){
            mixpanel.add_group("company", companyName);
            this.setState({ 
               mixpanelGroupSet: companyName
            });
        }

        let cleanCompanyList = []

        for(const i in companies) {
            const obj = {
                "label": companies[i]["name"],
                "value": companies[i]["uuid"]
            }
            cleanCompanyList.push(obj)
        }

        const activeDashboardData = _.find(companies, { uuid: this.state.activeDashboard.value })

        const renderFavicon = () => {
            if (activeDashboardData) {
                return <Helmet>
                    <link rel="shortcut icon" href={activeDashboardData.favicon} />
                </Helmet>
            }
        }
        
        return (
            <DashboardProviders>
                <div className="app-container">
                    <GlobalStyles />
                    <GlobalScrollbar />
                    <GlobalFonts />
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        timeout={1000 * 60 * Number(process.env.REACT_APP_INACTIVE_EXPIRE_TIME)}
                        onAction={this.handleOnAction.bind(this)}
                        throttle={1000 * 60 * Number(process.env.REACT_APP_TOKEN_REFRESH_TIME)}
                    />
                    
                    {!dashboardSwitch &&
                        <>
                            <TopNavBar
                                selectedLanguage={selectedLanguage}
                                showLanguages={translatedPages.includes(url) && !permissions.solution_goals}
                                companyList={cleanCompanyList}
                                activeDashboard={this.state.activeDashboard}
                                onChangeCompany={this.handleCompanySelect.bind(this)}
                                onChangeLanguage={handleLanguageChange}
                                onShowPastSurveys={() => this.showPastSurveys(true)}
                            />             
                        
                            <Navbar />
                        </>

                    }
                    
                    {
                        this.props.displayAnonymityWarning 
                        ? <Toast className='anonymity-warning' type='error' message='Anonymity is disabled for this company for Diversio staff accounts, client accessing this dashboard might see different scores/values. Please make sure to disable it you’re going to use this dashboard for a demo.' open variant='slim'/>
                        : null
                    }
                    {
                        this.state.pastSurveysActive
                        ? <SurveyInformation isOpen={this.state.pastSurveysActive} setIsOpen={(status) => this.showPastSurveys(status)}/>
                        : null
                    }
                    
                    <Company permissions={permissions} url={url} companyInformation={companyInformation} setActiveDashboard={this.setActiveDashboard.bind(this)} />

                    {renderFavicon()}

                    <VersionsContext.Consumer>
                        {versionsContext => {
                            const isV2Enabled = versionsContext?.version === versionsContext?.AVAILABLE_VERSIONS.v2
                            if (this.state.isV2Enabled !== isV2Enabled) {
                                this.setState({
                                    isV2Enabled
                                })
                            }
                        }}
                    </VersionsContext.Consumer>

                    <Tour />

                    <VersionSwitch />

                    <RenewDialog />
                </div>
            </DashboardProviders>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        isDefaultAuthenticated: state.auth.isDefaultAuthenticated,
        enableDebugMode: state.auth.enableDebugMode,
        showNps: state.auth.showNps,
        username: state.auth.username,
        email: state.auth.email,
        loggedinUserId: state.auth.loggedinUserId,
        displayAnonymityWarning: state.analyze.filters.display_anonymity_warning,
        selectedLanguage: state.app.selectedLanguage,
        profile: state.profile,
    }
};

export default connect(mapStateToProps, Actions)(withTranslation()(withHooks(Dashboard)));
